<template>
  <div>
    <aboutWeb v-if="!isMobile"></aboutWeb>
    <aboutMobile v-if="isMobile"></aboutMobile>
  </div>
</template>
<script>
import aboutWeb from './About-web.vue'
import aboutMobile from './About-mobile.vue'
export default {
  name: 'about',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    aboutWeb,
    aboutMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
